import React from "react";
import { GoDotFill } from "react-icons/go";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

import Login from "components/auth/Login";
import Registration from "components/auth/Registration";
import ResetPassword from "components/auth/ResetPassword";
import { MODES, info } from "components/auth/constants";
import logo from "./logo.svg";

const Auth = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get("mode");

  return (
    <div className="flex xl:flex-row flex-col justify-center items-center gap-[24px] mt-[24px] p-[24px] md:py-[48px] md:px-[160px] rounded-[24px] bg-white xl:h-[800px] mb-[24px]">
      <div className="flex flex-col gap-[24px] items-center w-full">
        <div className="flex items-center self-stretch gap-[24px]">
          <img src={logo} alt="logo" className="w-[186px] h-[66px]" />
          <span className="text-[14px] w-[156px]">
            Կանխատեսումների ճշգրտության քարտեզ
          </span>
        </div>
        <div className="text-[14px]">
          <span>
            Ո՞վ է իրականում տեսնում ապագան, և ով պարզապես ենթադրում։ Prognos-ը
            գնահատում է կանխատեսումների արժանահավատությունը՝ հիմնվելով փաստերի
            վրա։
          </span>
        </div>
        <div className="flex flex-col gap-[12px]">
          {info.map((i, index) => {
            return (
              <div
                key={index}
                style={{ flex: "1 0 0" }}
                className="flex flex-col gap-[6px] items-start bg-white rounded-[24px]"
              >
                <div className="flex items-center gap-2">
                  <GoDotFill size={10} color="#03F" />
                  <span className="relative text-[#03F] text-[14px] font-[600]">
                    {i.title}
                  </span>
                </div>
                <span className="text-[#212121] text-[14px] ml-4">
                  {i.description}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      <motion.div
        key={mode} // Forces re-render on mode change
        initial={{ rotateY: 90, opacity: 0 }}
        animate={{ rotateY: 0, opacity: 1 }}
        exit={{ rotateY: -90, opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full"
      >
        {mode === MODES.LOGIN && <Login />}
        {mode === MODES.REGISTRATION && <Registration />}
        {mode === MODES.RESET && <ResetPassword />}
      </motion.div>
    </div>
  );
};

export default Auth;
